import React from "react";
import GoogleAd from "./GoogleAd.jsx";
const FreeGameAd = ({show}) => {

    if (!show) {
        return null;
    }

    return <div className="free-game-ad">
        <GoogleAd style={{display:'block', width:970, height:250}} client="ca-pub-8704784142786369" slot="3047906807"/>
    </div>
};

export default FreeGameAd;